export function selectedLineIds(quote, optionalSelection = {}) {
  return (quote?.lines || [])
    .filter((line) => !line.optional || Boolean(optionalSelection[line.id]))
    .map((line) => line.id)
}

export function selectedQuoteTotal(quote, optionalSelection = {}) {
  const included = new Set(selectedLineIds(quote, optionalSelection))
  const subtotal = (quote?.lines || []).reduce(
    (sum, line) => sum + (included.has(line.id) ? Number(line.line_total || 0) : 0),
    0,
  )
  return Math.max(0, subtotal - Number(quote?.promotion_discount || 0))
}

export function responseQuoteTotal(quote, response) {
  const included = new Set(response?.selected_line_ids || [])
  const subtotal = (quote?.lines || []).reduce(
    (sum, line) => sum + (included.has(line.id) ? Number(line.line_total || 0) : 0),
    0,
  )
  return Math.max(0, subtotal - Number(quote?.promotion_discount || 0))
}
